module.exports = __webpack_public_path__ + "img/cs-logo-1-blanco.3efe7128.svg";